const mapPinSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="25.298px" height="30.145px" viewBox="0 0 25.298 30.145" enable-background="new 0 0 25.298 30.145" xml:space="preserve">
<g id="Layer_1">
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
	<g>
		<g>
			<g>
				<g>
					<path fill="#FFFFFF" d="M3.442,21.315l8.565,8.569c0.175,0.173,0.411,0.26,0.64,0.26c0.232,0,0.464-0.087,0.638-0.26
						l8.588-8.593c0.978-1.036,1.761-2.218,2.331-3.5c0.725-1.619,1.094-3.353,1.094-5.144C25.298,5.671,19.626,0,12.647,0
						C5.67,0,0,5.671,0,12.648c0,1.791,0.365,3.524,1.089,5.144C1.661,19.074,2.449,20.256,3.442,21.315z M12.647,1.804
						c5.981,0,10.849,4.864,10.849,10.842c0,1.538-0.316,3.022-0.941,4.409c-0.489,1.104-1.163,2.11-1.975,2.982l-7.933,7.933
						l-7.906-7.909c-0.835-0.892-1.508-1.902-2-3.013c-0.622-1.38-0.936-2.86-0.936-4.399C1.806,6.668,6.668,1.804,12.647,1.804z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#FFFFFF" d="M12.647,18.067c2.992,0,5.426-2.434,5.426-5.422c0-2.985-2.434-5.422-5.426-5.422
						c-2.989,0-5.421,2.437-5.421,5.425C7.227,15.642,9.658,18.067,12.647,18.067z M12.647,9.034c1.994,0,3.615,1.619,3.615,3.614
						c0,1.997-1.621,3.615-3.615,3.615c-1.992,0-3.611-1.618-3.611-3.615C9.036,10.653,10.658,9.034,12.647,9.034z"/>
				</g>
			</g>
		</g>
	</g>
</g>
</svg>

`;


export default mapPinSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/mapPinSVG.js